import { roundDown, roundToTwo } from '@/utils/helpers';

const CURRENCY_CENTS = '&cent;';
const CURRENCY_DOLLARS = '$';


function setPrice(el, binding) {
  const sourcePrice = binding.value || 0;
  let absolutePrice = Math.abs(sourcePrice);
  if (binding.modifiers.round2) {
    absolutePrice = roundToTwo(absolutePrice);
  }
  let currency = (binding.modifiers.cents) ? CURRENCY_CENTS : CURRENCY_DOLLARS;
  // Display 100cents as $1
  if (absolutePrice === 100 && currency === CURRENCY_CENTS) {
    currency = CURRENCY_DOLLARS;
    absolutePrice = 1;
  }
  let formattedPrice = absolutePrice;
  if (binding.modifiers.floor) { absolutePrice = roundDown(absolutePrice); }
  if (binding.modifiers.fixed) { formattedPrice = absolutePrice.toFixed(2); }
  if (binding.modifiers.fixed3) { formattedPrice = absolutePrice.toFixed(3); }
  if (binding.modifiers.fixedflex) {
    formattedPrice = absolutePrice > 1000 ? absolutePrice.toFixed(0) : absolutePrice.toFixed(2);
  }
  const p = formattedPrice.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  const text = (currency === CURRENCY_CENTS) ? `${p}${currency}` : `${currency}${p}`;
  el.innerHTML = (sourcePrice >= 0) ? text : `(${text})`;
}

export default {
  bind(el, binding) {
    setPrice(el, binding);
  },
  update(el, binding) {
    setPrice(el, binding);
  },
};



// WEBPACK FOOTER //
// ./src/directives/price-display.js